import { NgModule } from '@angular/core';
import { IconModule } from 'src/app/components/icon/icon.module';

import { SharedModule } from '../../shared/shared.module';

import { NotificationItemModule } from '../notification-item/notification-item.module';
import { NotificationPopupComponent } from './notification-popup.component';
import { ButtonModule } from 'src/app/components/button/button.module';
import { BucketModule } from '../../pages/rule/bucket/bucket.module';

@NgModule({
  imports: [
    ButtonModule,
    IconModule,
    SharedModule,
    NotificationItemModule,
    BucketModule,
  ],
  declarations: [NotificationPopupComponent],
  exports: [NotificationPopupComponent],
})
export class NotificationPopupModule {}
